import React from 'react'
import { Box, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useMutation } from '@apollo/react-hooks'

import { CorporateForm, ICorporateFormValues } from './CorporateForm'
import { CREATE_CORPORATION, GET_CORPORATIONS_BY_ADMIN } from '../../../graphql/queries/businesses'
import { CORPORATIONS_ROWS_PER_PAGE } from '../../../graphql/hooks/businesses'

interface IProps {
  open: boolean
  onCancel: () => void
}

export const AddCorporateModal: React.FC<IProps> = ({ open, onCancel }) => {
  const [error, setError] = React.useState<string | undefined>(undefined)

  const [createCorporation, { loading }] = useMutation(CREATE_CORPORATION, {
    refetchQueries: [
      {
        query: GET_CORPORATIONS_BY_ADMIN,
        variables: {
          pagination: { offset: 0, limit: CORPORATIONS_ROWS_PER_PAGE[0] },
        },
      },
    ],
  })

  const handleSubmit = async (values: ICorporateFormValues) => {
    try {
      await createCorporation({
        variables: {
          input: {
            corporationName: values.corporationName,
            countryId: values.countryId ?? undefined,
            citiesIds: values.citiesIds ?? undefined,
            corporationTypesIds: values.corporationTypesIds ?? undefined,
          },
        },
      })
      onCancel()
    } catch (error) {
      setError((error as Error).message || 'Произошла ошибка')
    }
  }

  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle id='form-dialog-title'>Новая корпорация</DialogTitle>
      <DialogContent>
        {!!error && (
          <Box mb={3}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}
        <Box>
          <CorporateForm loading={loading} onSubmit={handleSubmit} onCancel={onCancel} />
        </Box>
      </DialogContent>
    </Dialog>
  )
}
